import React, { useState, useEffect, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import editImage from "../../assets/images/icons/edit-2.svg";
import DeleteIcon from "../../assets/images/icons/delete-w.svg";
import Cuisine from "../../assets/images/img.webp";
import { Link } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { UI_CONSTANTS } from "../../utils/constants";
import TablePagination from "../../commons/Pagination/TablePagination";

function CuisineList() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  const getList = useCallback(async () => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        page,
        limit,
        ...(search && { name: search }),
      }).toString();

      const response = await handleApiCall("get", `${endpoints.cuisineList}?${query}`);
      if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        setData(response?.data?.data?.data || []);
        setTotalPages(response?.data?.data?.pagination?.totalPages || 1);
      }
    } catch (error) {
      console.error("Error fetching cuisine list:", error);
    } finally {
      setLoading(false);
    }
  }, [page, limit, search]);

  useEffect(() => {
    getList();
  }, [getList]);

  const block = async (status, id) => {
    try {
      const response = await handleApiCall("patch", `${endpoints.cuisineBlock}/${id}`, {
        status,
      });
      if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        toast.success(response?.data?.message || UI_CONSTANTS.TOAST_MESSAGES.SUCCESS.STATUS_UPDATED);
        getList();
      }
    } catch (error) {
      console.error("Error cuisine:", error);
      // Network errors are already handled by handleApiCall
    }
  };

  const deleteCuisine = async (id) => {
    if (window.confirm(UI_CONSTANTS.CONFIRMATION_MESSAGES.DELETE_CUISINE)) {
      try {
        const response = await handleApiCall("delete", `${endpoints.cuisineDelete}?cuisineId=${id}`);
        if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
          toast.success(UI_CONSTANTS.TOAST_MESSAGES.SUCCESS.CUISINE_DELETED);
          getList();
        }
      } catch (error) {
        console.error("Error cuisine:", error);
        // Network errors are already handled by handleApiCall
      }
    }
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">{UI_CONSTANTS.PAGE_TITLES.CUISINE_LIST}</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <div className="card-heading d-flex align-items-center mb-3 pb-2">
                <div className="d-flex align-items-center col-md-12 px-0">
                  <form className="col-md-3 px-0">
                    <div className="form-group my-0">
                      <input
                        className="form-control search-icon left-icon border"
                        placeholder={UI_CONSTANTS.PLACEHOLDERS.SEARCH}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                  </form>
                  <Link to={UI_CONSTANTS.ROUTES.ADD_CUISINE} className="ml-auto btn btn-primary">
                    {UI_CONSTANTS.BUTTON_LABELS.ADD_NEW}
                  </Link>
                </div>
              </div>
              <div className="col-md-12 tab-content row px-0 mx-0">
                <div className="table-responsive px-0">
                  <table className="table table-striped trim">
                    <thead>
                      <tr>
                        <th width="80" class="text-center">
                          {UI_CONSTANTS.TABLE_HEADERS.ID}
                        </th>
                        <th width="150">{UI_CONSTANTS.TABLE_HEADERS.NAME}</th>
                        <th>Image</th>
                        <th>{UI_CONSTANTS.TABLE_HEADERS.STATUS}</th>
                        <th className="text-center">{UI_CONSTANTS.TABLE_HEADERS.ACTIONS}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            {UI_CONSTANTS.BUTTON_LABELS.LOADING}
                          </td>
                        </tr>
                      ) : data.length > 0 ? (
                        data.map((cuisine, index) => (
                          <tr key={cuisine._id || index}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            {/* <td>#{cuisine._id?.slice(-8) || index + 1}</td> */}
                            <td className="text-center">{cuisine.name || "N/A"}</td>
                            <td>
                              <div className="sm-img">
                                <img
                                  src={cuisine.image || Cuisine}
                                  alt={cuisine.name}
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            </td>
                            <td>
                              <label className="custom-control custom-switch p-1 ml-4 mb-0 mt-1" role="button">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  checked={cuisine.status === 1}
                                  onChange={() => block(cuisine.status === 1 ? 0 : 1, cuisine._id)}
                                />
                                <span className="custom-control-label custom-toggle" />
                              </label>
                            </td>
                            <td>
                              <div className="d-flex align-items-center justify-content-center">
                                <button
                                  onClick={() => {
                                    // Store cuisine data in localStorage for the edit page
                                    localStorage.setItem(UI_CONSTANTS.LOCAL_STORAGE_KEYS.SELECTED_CUISINE, JSON.stringify(cuisine));
                                    window.location.href = `${UI_CONSTANTS.ROUTES.EDIT_CUISINE}/${cuisine._id}`;
                                  }}
                                  className="btn btn-link p-0 mx-2"
                                >
                                  <img src={editImage} alt={UI_CONSTANTS.BUTTON_LABELS.EDIT} className="mr-2" />
                                </button>
                                {/* <button onClick={() => deleteCuisine(cuisine._id)} className="btn btn-link p-0">
                                  <img src={DeleteIcon} alt={UI_CONSTANTS.BUTTON_LABELS.DELETE} />
                                </button> */}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            {UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <TablePagination page={page} totalPages={totalPages} onPageChange={setPage} />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CuisineList;
